import { render, staticRenderFns } from "./Init.vue?vue&type=template&id=5f34b77a&"
import script from "./Init.vue?vue&type=script&lang=ts&"
export * from "./Init.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports